export const FETCH_SUPPLIER_INCOME_REQUEST = "FETCH_SUPPLIER_INCOME_REQUEST";
export const FETCH_SUPPLIER_INCOME_SUCCESS = "FETCH_SUPPLIER_INCOME_SUCCESS";
export const FETCH_SUPPLIER_INCOME_FAILURE = "FETCH_SUPPLIER_INCOME_FAILURE";
